import React from "react";
import { Navbar } from "react-bootstrap";
import { _t } from "../../i18n/i18n";
import { useLocation } from "react-router";

const HeaderTitle = () => {
  const { pathname } = useLocation();
  const title = titleFromPath(pathname);
  return <Navbar.Brand className="mr-auto ml-3 font-weight-lighter overflow-x-auto">{_t(title)}</Navbar.Brand>;
};

export const titleFromPath = (pathname) => capitalise(lastItem(pathname.split("/")) || "Latest Research");
const capitalise = (str) => str.replace("__", "/").replace(/_/g, " ");

export default HeaderTitle;

const lastItem = (arr) => arr[arr.length - 1];
